import React from "react";
import { KeyRound } from "lucide-react";

export function Logo({ compact = false, onDark = false }) {
  return (
    <div className="flex items-center gap-2 select-none" data-testid="autotu-logo">
      <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground">
        <KeyRound className="h-5 w-5" strokeWidth={2.4} />
      </div>
      {!compact && (
        <div className="leading-none">
          <span className={`font-heading text-xl font-extrabold tracking-tight ${onDark ? "text-white" : "text-foreground"}`}>
            Auto<span className={onDark ? "text-sky-200" : "text-primary"}>Tu</span>
          </span>
          <p className={`text-[10px] font-medium uppercase tracking-widest ${onDark ? "text-white/70" : "text-muted-foreground"}`}>Fleet Manager</p>
        </div>
      )}
    </div>
  );
}
